import { mutate } from 'swr'

import {
  patchJson,
  postJson,
  putJson,
  requestDelete,
} from '../../../data/fetchers'
import {
  Attachment,
  DespatchAdvice,
  DespatchAdviceItem,
  PatchRequest,
  WebEdiDto,
} from '../../../data/models'

// patch
export async function requestPatchDespatchAdviceById(
  despatchAdviceId: string,
  despatchAdviceDto: PatchRequest<WebEdiDto<DespatchAdvice>>,
): Promise<any> {
  const result = await patchJson(
    `/DespatchAdvices/${despatchAdviceId}`,
    despatchAdviceDto,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith(`/DespatchAdvices/${despatchAdviceId}`.toLowerCase()),
  )

  return result
}

// complete
export async function requestCompleteDespatchAdviceById(
  despatchAdviceId: string,
  despatchAdviceDto: PatchRequest<WebEdiDto<DespatchAdvice>>,
): Promise<any> {
  return await patchJson(
    `/DespatchAdvices/${despatchAdviceId}/complete`,
    despatchAdviceDto,
  )
}

// put despatchAdviceItem
export async function requestPutDespatchAdviceItemById(
  despatchAdviceId: string,
  itemId: string,
  despatchAdviceDto: DespatchAdviceItem,
): Promise<any> {
  const result = await putJson(
    `/DespatchAdvices/${despatchAdviceId}/Items/${itemId}`,
    despatchAdviceDto,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith(`/DespatchAdvices/${despatchAdviceId}`.toLowerCase()),
  )

  return result
}

export async function requestAttachmentUpload(
  despatchAdviceId: string,
  processId: string,
  attachment: { attachment: File; category: string },
) {
  const { attachment: file, category } = attachment

  const attObj: Omit<Attachment, 'Id'> = {
    Name: file.name,
    Type: 'additional',
    Category: category,
    MimeType: file.type,
  }

  const formData = new FormData()
  formData.append('processId', processId)
  formData.append('file', file)
  formData.append('attachment', JSON.stringify(attObj))

  const result = await postJson(
    `/DespatchAdvices/${despatchAdviceId}/Attachments`,
    formData,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith(`/DespatchAdvices/${despatchAdviceId}`.toLowerCase()),
  )

  return result
}

export async function requestAttachmentDelete(
  despatchAdviceId: string,
  attachmentId: string,
  attachmentUri: string,
) {
  const result = await requestDelete(
    `/DespatchAdvices/${despatchAdviceId}/Attachments/${attachmentId}`,
    {
      'Xia-AttachmentUri': encodeURI(attachmentUri),
    },
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith(`/DespatchAdvices/${despatchAdviceId}`.toLowerCase()),
  )

  return result
}
